import { useState } from 'react';
import { AxiosError, AxiosRequestConfig } from 'axios';
import { IPartnerRatingByRealEstate } from '../interfaces';
import { getPartnerRatingByRealEstate } from '../api';

export function useGetPartnerRatingByRealEstate() {
  const [{ loading, data, error, success }, setData] = useState<{
    loading: boolean;
    error: string | null;
    data: Map<string, { list: IPartnerRatingByRealEstate[]; totalCount: number }>;
    success: boolean;
  }>({ loading: false, error: null, data: new Map(), success: false });

  const fetchPartnerRatingByRealEstate = async (config: AxiosRequestConfig) => {
    const mapKey = JSON.stringify(
      Object.entries(config.params)
        .map(([, value]) => value)
        .filter(Boolean),
    );
    if (data.has(mapKey)) return;

    setData((prevState) => ({ ...prevState, loading: true, success: false }));

    try {
      const response = await getPartnerRatingByRealEstate(config);

      setData((prevState) => {
        const newData = new Map(prevState.data);
        newData.set(mapKey, response);
        return { ...prevState, data: newData, success: true };
      });
    } catch (error) {
      setData((prevState) => ({ ...prevState, error: (error as AxiosError).response?.data.message }));
    } finally {
      setData((prevState) => ({ ...prevState, loading: false }));
    }
  };

  return { loading, data, error, success, fetchPartnerRatingByRealEstate };
}
